import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserRolesService } from 'src/app/services/user-roles.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-userrole',
  templateUrl: './userrole.component.html',
  styleUrls: ['./userrole.component.scss']
})
export class UserroleComponent implements OnInit {
  public userRoleId;
  public userRole;
  public loading:boolean=true;

  constructor(
    private _activeRoute: ActivatedRoute,
    private _userRole: UserRolesService,
    private _notify: NotificationService
  ) {
    this.userRoleId=this._activeRoute.snapshot.paramMap.get('id');
  }

  public updateUserRole(){
    if(this.userRole.role=='') return this._notify.showMessage('Role Name must not be blank.', 'OK');
    this._userRole.updateUserRole(this.userRole.role, this.userRole.id).subscribe(res=>{
      this.userRole=res;
      this._notify.showMessage('User Role updarted.', 'OK');
    });
  }

  ngOnInit() {
    this._userRole.getUserRole(this.userRoleId).subscribe(res=>{
      this.userRole=res;
      this.loading=false;
    });
  }

}
